module.exports = __webpack_public_path__ + "img/success.4d7b3040.png";